import { cardHeight, CardTemplateProps, cardWidth } from "../id-card-helpers";
import dentanet from "../../../images/id-cards/DentaNet.png";
import { twinPinesLogo } from "../id-card-logos";
import { Col, Row } from "react-bootstrap";

export default function DrummondTwinPinesIdCard({ memberBenefits }: CardTemplateProps) {
    const { lastName, firstName, middleName } = memberBenefits[0];

    return (
        <div className="id-card">
            <div className="front">
                <div className="d-flex justify-content-between">
                    <span style={{ fontWeight: 700, fontStyle: "italic", fontSize: "20px" }}>
                        Southland Benefit
                        <br />
                        Solutions, LLC
                    </span>
                    <img
                        src={dentanet}
                        alt="DentaNet logo"
                        style={{
                            maxHeight: cardHeight * 0.25,
                            maxWidth: cardWidth * 0.25,
                            height: "auto",
                            width: "auto",
                        }}
                    />
                </div>
                <table style={{ fontSize: "18px" }}>
                    <tbody>
                        <tr>
                            <td className="text-start pe-3">I.D. #</td>
                            <td className="text-start">{memberBenefits[0].participantIDNumber}</td>
                        </tr>
                        <tr>
                            <td className="text-start pe-3">INSURED</td>
                            <td className="text-start">
                                {lastName.toUpperCase()}, {firstName.toUpperCase()} {middleName.toUpperCase()}
                            </td>
                        </tr>
                        <tr>
                            <td className="text-start pe-3">GROUP #</td>
                            <td className="text-start">{memberBenefits[0].groupNumber}</td>
                        </tr>
                    </tbody>
                </table>
                <Row>
                    <Col className="d-flex justify-content-end">{twinPinesLogo}</Col>
                </Row>
                <div className="text-center fw-bold">Dental Identification Card</div>
            </div>
            <div className="back" style={{ fontSize: "13px" }}>
                <p>
                    <strong>
                        Plan administered on behalf of Twin Pines, LLC by:
                        <br />
                        Southland Benefit Solutions, LLC
                        <br />
                        P.O. Box 1250
                        <br />
                        Tuscaloosa, Alabama 35403-1250
                    </strong>
                </p>
                <p>
                    Claims for services provided to the member on the front side of this card or any eligible
                    dependents, should be sent directly to the Southland National Insurance Corporation at the address
                    above.
                </p>
                <p>
                    By using this card, you and any covered dependents agree to the terms set froth when the card was
                    issued. Possession of this card does not guarantee eligibility. To verify benefits, please call
                    1-800-476-3010.
                </p>
            </div>
        </div>
    );
}
